module.exports = __webpack_public_path__ + "static/img/logotipoBlanco.287e9600.png";